import { useQuery, UseQueryResult } from 'react-query';
import { PackageRetrieve } from 'types';
import { client } from 'utils/api-client';

function usePackage(packageId: string | undefined): UseQueryResult<{ data: PackageRetrieve }> {
  return useQuery(['packages', packageId], () => client.get(`packages/${packageId}/`), {
    enabled: !!packageId,
  });
}

export default usePackage;
